import { useState, useEffect } from 'react';
import { API } from 'aws-amplify';
import { hydrateEntry } from './hydrateEntry';

/**
 * Custom React hook to fetch multiple Contentful entries by array of link objects.
 * @param {Array} items - Array of Contentful link objects (e.g., [{ sys: { id: ... } }, ...])
 * @returns {object} { entries, loading, error }
 */
export function useContentfulMultipleEntry(items) {
  const [entries, setEntries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!items || items.length === 0) {
      setEntries([]);
      setLoading(false);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);

    const fetchEntries = async () => {
      try {
        const promises = items.map(item =>
          API.get('content', '/content', { queryStringParameters: { 'sys.id': item.sys.id } })
        );
        const results = await Promise.all(promises);
        const hydratedEntries = results.map(result => {
          if (!result || !result.items || result.items.length === 0) return null;
          const entry = result.items[0];
          const includes = result.includes || {};
          hydrateEntry(entry, includes);
          return entry;
        });
        setEntries(hydratedEntries);
        setLoading(false);
      } catch (err) {
        setError(err);
        setEntries([]);
        setLoading(false);
      }
    };

    fetchEntries();
  }, [items]);

  return { entries, loading, error };
}
